import { defineMessages } from '@formatjs/intl';

const messages = defineMessages({
	signupFormHeadingNoDiscount: {
		id: 'annual.discount.signup.title.2.noDiscount',
		defaultMessage: 'Sleep better and stress less today',
		description: 'The title for the Calm signup component',
	},
	signupFormHeading: {
		id: 'annual.discount.signup.title.2',
		defaultMessage: 'Try Calm Premium for 1 year for {percentOff}% off!',
		description: 'The title for the Calm signup component with percent off',
	},
	loginFormHeading: {
		id: 'annual.discount.login.title',
		defaultMessage: 'Log into your Calm account',
		description: 'The title for the Calm login component',
	},
	accountValuePropHeaderNoDiscount: {
		id: 'annual.discount.account.valueproplist.header.noDiscount',
		defaultMessage: 'Continue your mindfulness journey with Calm Premium',
		description: 'Value props of calm with Calm Premium',
	},
	accountValuePropHeader: {
		id: 'annual.discount.account.valueproplist.header',
		defaultMessage: 'Continue your mindfulness journey with {percentOff}% off Calm Premium',
		description: 'Value props of calm with a percentage off Calm Premium',
	},
	terms: {
		id: 'annual.discount.payment.terms.short2',
		defaultMessage:
			'This yearly membership gives you unlimited access to Calm’s entire library of content. You will be charged {price} for a 1 year subscription that will renew at {originalPrice}, billed annually.',
		description: 'A line to inform the user of the terms of their trial',
	},
	offerTerms: {
		id: 'purchaseTerms.noTrialTermsEligibility2',
		defaultMessage:
			'By clicking "Get Calm Premium", you agree to be automatically billed for Calm Premium at {price} for a 1 year subscription that will renew at {originalPrice}, billed annually. <cancelAnytimeLink>Cancel anytime</cancelAnytimeLink>.',
		description: 'Terms for if user is not eligible for trial',
	},
});

export default messages;
